import { useShallow } from 'zustand/react/shallow'

import { STORE_STATUS } from '@/constants/store'
import { useFailedProvisionStore } from '@/stores/pipelineCheck'

import { FilterableTable } from '../table/base'
import { PIPELINE_FAILED_HEADERS, pipelineFailedProvisionFilters } from './failedProvision.table'
import { PIPELINE_NO_DATA } from './utils'

const tableId = 'pipeline-failed-provision-table'

export const PipelineCheckFailedProvisionTable = () => {
  const { data, isFetching, isLoading } = useFailedProvisionStore(
    useShallow((state) => ({
      data: state.data,
      isLoading: state.status === STORE_STATUS.loading,
      isFetching: state.status === STORE_STATUS.fetching
    }))
  )

  return (
    <FilterableTable
      data={data}
      tableId={tableId}
      loading={isLoading}
      fetching={isFetching}
      columns={PIPELINE_FAILED_HEADERS}
      noDataMessage={PIPELINE_NO_DATA}
      filters={pipelineFailedProvisionFilters}
      clientSideFilters
      clientSideSortAndPagination
    />
  )
}
